import React, { useEffect, useState } from "react";
import styles from "./../cruise.module.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import { deleteIcon, editIcon } from "../../../../utils/svg.file";

import { Featured_URL, Offers_URL } from "../../../../serverUrl";
import DeleteModal from "../../../component/modal/deleteModal";
import swal from "sweetalert";
import {
  deleteCruiseEnquiry,
  showCruiseEnquriyList,
  showRestaurantBanner,
  showRetreatBanner,
} from "../../../../api/adminPanel/giftCardApi";

export default function ManageCruiseEnquirySection() {
  const navigate = useNavigate();
  const [bannerList, setbannerList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");
  const [deleteId, setDeletedId] = useState("");
  const columns = [
    { field: "id", headerName: "SNo.", width: 100 },

    { field: "name", headerName: "Cruise Name", width: 350 },
    { field: "title", headerName: "Package Name", width: 350 },

    {
      field: "Action",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>
            <span
              className={styles.edit_icon_btn}
              onClick={() => {
                navigate(
                  `/edit-cruise-enquiry-section/${cellValues.row.id}`
                );
              }}
            >
              {editIcon}
            </span>
            <span
              className={styles.delete_icon_btn}
              onClick={() => {
                handleShowDeleteModal(cellValues.row.id);
              }}
            >
              {deleteIcon}
            </span>
          </>
        );
      },
    },
  ];
  const handleShowDeleteModal = (id) => {
    setDeletedId(id);
    setShowDeleteModal(true);
  };
  const hideDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const handleDelete = async (id) => {
    const response = await deleteCruiseEnquiry(id);

    if (response.remote === "success") {
      hideDeleteModal();
      swal("Deleted Successfully!");
      handelRetreatBanner()
    } else {
    }
  };
  const handelRetreatBanner = async () => {
    const response = await showCruiseEnquriyList();
    if (response.remote === "success") {
      setbannerList(response.data.data);
    } else {
    }
  };
  useEffect(() => {
    handelRetreatBanner();
  }, []);

  return (
    <>
      <div className={styles.job_list_page}>
        <div className="">
          <div className={styles.card_body}>
            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
              <div className={styles.page_title}>
                <h3>Manage Cruises Package Section</h3>
              </div>
              <Button
                className={styles.main_button}
                onClick={() => navigate("/add-cruise-enquiry-section")}
              >
                Add
              </Button>
            </div>
            <Table rows={bannerList} columns={columns} />
          </div>
        </div>
      </div>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleDelete={handleDelete}
        hideDeleteModal={hideDeleteModal}
        handleShowDeleteModal={handleShowDeleteModal}
        deleteId={deleteId}
      />
    </>
  );
}
